const accAdd = (arg1: number, arg2: number):number => {
  let r1 = deal(arg1);
  let r2 = deal(arg2);
  let m = Math.pow(10, Math.max(r1, r2))
  return (arg1 * m + arg2 * m) / m
}
const deal = (arg: number): number => {
  let t = 0;
  try {
    t = arg.toString().split(".")[1].length
  } catch (e) { }
  return t;
}
//节流(ts)
class Throttle {
	public use (fn: { apply: (arg0: any, arg1: any[]) => void }, t: number): Function {
		let flag = true
		const interval = t || 1500
		return function (this: any, ...args: any) {
			if (flag) {
				fn.apply(this, args)
				flag = false
				setTimeout(() => {
					flag = true
				}, interval)
			}
		}
	}
}
//防抖(ts)
class Debounce {
	public use (fn: { apply: (arg0: any, arg1: any) => void }, t: number): Function {
		let timeId: any = null
		const delay = t || 1500
		return function (this: any, ...args: any) {
			if (timeId) {
				clearTimeout(timeId)
			}
			timeId = setTimeout(() => {
				timeId = null
				fn.apply(this, args)
			}, delay)
		}
	}
}
export {
	accAdd,
	Throttle,
	Debounce,
}